import type { ClientSideTableFilterFunction } from "~components/DataTable/types/clientSideTableFilterFunction.ts";

const normalizeFilterValue = (value: unknown): unknown => {
  if (typeof value === "string") {
    return value.toLowerCase();
  }

  return value;
};

const includesFilterValue = (selectedValues: unknown[], value: unknown): boolean => {
  const normalizedValue = normalizeFilterValue(value);

  return selectedValues.some((selectedValue) => normalizeFilterValue(selectedValue) === normalizedValue);
};

export const filterByTableField = <T extends object>(fieldName: keyof T): ClientSideTableFilterFunction<T> => {
  return (record, selectedValues) => {
    const fieldValue = record[fieldName];

    if (Array.isArray(fieldValue)) {
      return fieldValue.some((value) => includesFilterValue(selectedValues, value));
    }

    return includesFilterValue(selectedValues, fieldValue);
  };
};
